module.exports = __webpack_public_path__ + "static/img/wx_qrcode2.8e08691b.jpg";